import moment from 'moment';
import { rrulestr } from 'rrule';

const MAX_RES_LEN = 4;

export const getFilmDatesRecurrence = (item, ellipsis = true) => {
  let dates = item.recurrence
    ? rrulestr(item.recurrence, {
        compatible: true,
        forceset: true,
      })
        .all()
        .map((date) => {
          return moment(date).format('DD/MM/YYYY');
        })
    : [];

  if (dates?.length === 0) {
    if (item.start) return moment(item.start).format('DD/MM/YYYY');
    return null;
  }
  let partial_date_list = null;
  let add_dots = false;
  if (ellipsis && dates?.length > MAX_RES_LEN) {
    partial_date_list = dates.slice(0, MAX_RES_LEN - 1);
    add_dots = true;
  } else {
    partial_date_list = dates;
  }
  let result = partial_date_list.join('; ');
  if (ellipsis && add_dots) {
    return result + ' ...';
  }
  return result;
};
